function debounce(func, wait = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), wait);
    };
}

export { debounce as d };
